// extracted by mini-css-extract-plugin
export var hackaway6logoClass = "v6-module--hackaway6logoClass--1FuuX";